import { render, staticRenderFns } from "./ScopeDialog.vue?vue&type=template&id=130b91e9"
import script from "./ScopeDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScopeDialog.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130b91e9')) {
      api.createRecord('130b91e9', component.options)
    } else {
      api.reload('130b91e9', component.options)
    }
    module.hot.accept("./ScopeDialog.vue?vue&type=template&id=130b91e9", function () {
      api.rerender('130b91e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Guide/components/SetupWizard/ScopeDialog.vue"
export default component.exports